// 验证手机号
export function validatMobile(str) {
  const phone = /^1[2|3|4|5|7|8][0-9]{9}$/;
  if (phone.test(str)) {
    return true
  }
  return false;
}
